var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-img',{attrs:{"fit":_vm.fit,"src":_vm.src,"width":_vm.width,"height":_vm.height,"quality":_vm.quality,"alt":_vm.alt,"format":"webp","loading":"lazy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }